import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import './Download.css';
import myFile from "./download/TonIK.pdf";
import myFile1 from "./download/diplo.pdf";
import myFile2 from "./download/diplo.zip";
import myFile3 from "./download/prezentacia.pdf";
import myFile4 from "./download/latex.zip"
import myFile5 from "./download/ukazka.wmv"


export default function Download() {
  return(
    <>
    <h1 className='downloads'>Download</h1>
    <div className = 'styleDownloads'>
    <h1>Programovací jazyk TonIK:  </h1>
    <a href={myFile} target = "_" > TonIK.pdf</a>
    </div>

    <div className = 'styleDownloads'>
    <h1>Text práce  </h1>
    <a href={myFile1} target = "_" > Diplomová praca</a>
    </div>


    <div className = 'styleDownloads'>
    <h1>Zdrojový kód  </h1>
    <a href={myFile4} target = "_" > LaTeX</a>
    </div>

    <div className = 'styleDownloads'>
    <h1>Video ukážka  </h1>
    <a href={myFile5} target = "_" > video</a>
    </div>

    <div className = 'styleDownloads'>
    <h1>Prezentácia na Projektový seminár 2:  </h1>
    <a href={myFile3} target = "_"> Prezentácia </a>
    </div>

    <div className = 'styleDownloads'>
    <h1>Prototyp:  </h1>
    <a href={myFile2} target = "_" > Prototyp </a>

    </div>
    <Footer />
    </>
  ) ;
}